import {
  SET_APP_THEME,
  SET_SHOW_POPUP,
  SET_MODAL_CHILDREN,
} from "../actionTypes/app.actionType";
import { Actions, AppIntitialState } from "../types";

const initialState: AppIntitialState = {
  appTheme: "dark",
  isPopupOpen: false,
  popupSize: "lg",
  closeIcon: false,
  modalChildren: null,
  onModalDismiss: () => {},
};

export function appReducer(state = initialState, action: Actions) {
  const { type, data, onDismiss } = action;
  switch (type) {
    case SET_APP_THEME:
      return {
        ...state,
        appTheme: data,
      };
    case SET_SHOW_POPUP:
      return {
        ...state,
        isPopupOpen: data.isPopupOpen,
        popupSize: data.size || "lg",
        closeIcon: data.closeIcon,
      };
    case SET_MODAL_CHILDREN:
      return {
        ...state,
        modalChildren: data,
        onModalDismiss: onDismiss,
      };
    default:
      return state;
  }
}
